import React from 'react';
import { motion } from 'framer-motion';
import { Lock, ZapOff, Activity } from 'lucide-react';
export function MechanismSection() {
  return <section className="py-20 bg-[#1a4d3e] text-white overflow-hidden relative" data-id="element-112">
      {/* Background pattern */}
      <div className="absolute inset-0 opacity-10" style={{
      backgroundImage: 'radial-gradient(#c9a227 1px, transparent 1px)',
      backgroundSize: '30px 30px'
    }} data-id="element-113"></div>

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-114">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-115">
          <motion.div initial={{
          opacity: 0,
          x: -50
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} data-id="element-116">
            <h2 className="text-3xl md:text-4xl font-serif font-bold mb-6 text-[#c9a227]" data-id="element-117">
              La Verdad Científica: Inflexibilidad Metabólica
            </h2>
            <p className="text-lg text-gray-200 mb-6 leading-relaxed" data-id="element-118">
              La ciencia moderna ha descubierto que después de los 40, las
              mujeres latinas enfrentamos un fenómeno donde tus hormonas se
              desincronizan.
            </p>
            <p className="text-lg text-gray-200 mb-8 leading-relaxed" data-id="element-119">
              Tu cuerpo entra en{' '}
              <strong className="text-white" data-id="element-120">
                "modo de almacenamiento de emergencia"
              </strong>
              . Mientras no arregles ese interruptor, ninguna dieta del mundo
              funcionará porque tu química interna está bloqueando la quema de
              grasa.
            </p>

            <div className="space-y-6" data-id="element-121">
              <div className="flex items-start" data-id="element-122">
                <div className="bg-white/10 p-3 rounded-lg mr-4" data-id="element-123">
                  <Activity className="text-[#c9a227]" size={24} data-id="element-124" />
                </div>
                <div data-id="element-125">
                  <h4 className="font-bold text-lg mb-1" data-id="element-126">Insulina Alta</h4>
                  <p className="text-gray-300 text-sm" data-id="element-127">
                    Ordena a tu cuerpo "guardar grasa" constantemente.
                  </p>
                </div>
              </div>

              <div className="flex items-start" data-id="element-128">
                <div className="bg-white/10 p-3 rounded-lg mr-4" data-id="element-129">
                  <ZapOff className="text-[#c9a227]" size={24} data-id="element-130" />
                </div>
                <div data-id="element-131">
                  <h4 className="font-bold text-lg mb-1" data-id="element-132">Cortisol Elevado</h4>
                  <p className="text-gray-300 text-sm" data-id="element-133">
                    El estrés bloquea la lipólisis (quema de grasa) y acumula
                    grasa visceral.
                  </p>
                </div>
              </div>

              <div className="flex items-start" data-id="element-134">
                <div className="bg-white/10 p-3 rounded-lg mr-4" data-id="element-135">
                  <Lock className="text-[#c9a227]" size={24} data-id="element-136" />
                </div>
                <div data-id="element-137">
                  <h4 className="font-bold text-lg mb-1" data-id="element-138">
                    Estrógenos Estancados
                  </h4>
                  <p className="text-gray-300 text-sm" data-id="element-139">
                    Provocan retención de líquidos y metabolismo lento.
                  </p>
                </div>
              </div>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="bg-white/5 backdrop-blur-sm rounded-2xl p-8 border border-white/10" data-id="element-140">
            <h3 className="text-2xl font-serif font-bold text-center mb-8" data-id="element-141">
              El Ciclo del Bloqueo
            </h3>

            <div className="relative h-80 flex items-center justify-center" data-id="element-142">
              {/* Visual representation of the cycle */}
              <div className="absolute w-64 h-64 border-2 border-dashed border-[#c9a227]/30 rounded-full animate-spin-slow" style={{
              animationDuration: '20s'
            }} data-id="element-143"></div>

              <div className="absolute top-0 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-[#1a4d3e] px-4 py-2 rounded-full border border-[#c9a227] shadow-lg" data-id="element-144">
                <span className="font-bold text-sm" data-id="element-145">Estrés / Edad</span>
              </div>

              <div className="absolute bottom-0 left-1/2 transform -translate-x-1/2 translate-y-1/2 bg-[#1a4d3e] px-4 py-2 rounded-full border border-[#c9a227] shadow-lg" data-id="element-146">
                <span className="font-bold text-sm" data-id="element-147">Grasa Abdominal</span>
              </div>

              <div className="absolute left-0 top-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-[#1a4d3e] px-4 py-2 rounded-full border border-[#c9a227] shadow-lg" data-id="element-148">
                <span className="font-bold text-sm" data-id="element-149">Insulina</span>
              </div>

              <div className="absolute right-0 top-1/2 transform translate-x-1/2 -translate-y-1/2 bg-[#1a4d3e] px-4 py-2 rounded-full border border-[#c9a227] shadow-lg" data-id="element-150">
                <span className="font-bold text-sm" data-id="element-151">Cortisol</span>
              </div>

              <div className="text-center z-10" data-id="element-152">
                <Lock size={48} className="text-[#c9a227] mx-auto mb-2" data-id="element-153" />
                <p className="font-bold text-xl" data-id="element-154">
                  Metabolismo
                  <br data-id="element-155" />
                  Bloqueado
                </p>
              </div>
            </div>

            <p className="text-center text-sm text-gray-300 mt-4 italic" data-id="element-156">
              "No es falta de voluntad, es química."
            </p>
          </motion.div>
        </div>
      </div>
    </section>;
}